/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */

export interface IShipmentData {
  readonly carrierName: string;
  readonly trackingCode: string | null;
  readonly trackingUrl: string | null;
  readonly shipmentState: shipmentState | null;
}

export enum shipmentState {
  CREATED = "CREATED",
  TRANSIT = "TRANSIT",
  DELAYED = "DELAYED",
  DELIVERING = "DELIVERING",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}
